export default (obj) => {
  return JSON.stringify(obj, (key, value) => {
    if(key !== '' && value === obj){
      return '[[Circular Reference]]';
    } else if(value instanceof HTMLElement){
      return value.outerHTML;
    }
    return value;
  })
}